import React from 'react';
import HeroSection from '../../../components/ProductsDetail/HeroSection';
import ProductShowcaseSection from '../../../components/ProductsDetail/ProductShowcaseSection';
import CTASection from '../../../components/ProductsDetail/CTASection';

// InfoBlocks
import {
  InfoSection,
  TypeBlock,
  UsageGrid,
  FeatureList,
  UsageSteps,
  VideoBlock,
} from '../../../components/ProductsDetail/InfoBlocks';
import SectionDivider from '../../../components/ProductsDetail/SectionDivider';
import ProductDetailNav from '../../../components/ProductsDetail/ProductDetailNav';


const PyrotechnicSign = () => {
  /* --- 제품 구성도(샘플 경로: 실제 파일 경로로 교체하세요) --- */
  const compositionGroups = [
    {
      items: [
        { src: '/images/products/traffic-safety/ignition.jpg', label: '점화 장치 본체' },
        { src: '/images/products/traffic-safety/emergency-flare.jpg', label: '불꽃신호기' },
      ],
    },
  ];

  const features = [
    {
      title: '자동 점화 방식으로 화상 및 사고 위험 제거',
      bullets: [
      {
        label: (
          <>점화 과정에서 손 또는 신체가 직접 불꽃에 닿지 않아 <strong>화상 및 안전사고 위험이 현저히 감소</strong></>
        ),
      },
      {
        label: (
          <>의복 손상, 차량 스크래치 등 수동식 사용 시 자주 발생하던 부작용을 완전히 해소</>
        ),
      },
      ]
    },
    {
      title: '누구나 쉽게 사용할 수 있는 간편한 조작버튼 작동으로 자동 점화',
      bullets: [
      {
        label: (
          <>복잡한 절차 없이도 초보자부터 현장 베테랑까지 누구나 즉시 사용 가능</>
        ),
      },
      {
        label: (
          <>긴급 상황에서도 신속한 신호 설치로 초기 대응력 향상</>
        ),
      },
      ]
    },
    {
      title: '안정적인 점화 성능',
      bullets: [

      {
        label: (
          <>기존 수동식에서 빈번하게 발생하던 <strong>착화 실패 문제를 해결</strong></>
        ),
      },
      {
        label: (
          <>다양한 기상환경(비·눈·바람)에서도 안정적인 점화 유지</>
        ),
      },
      {
        label: (
          <>경고 신호가 확실히 발생되어 돌발 상황의 인지가 더욱 명확해짐</>
        ),
      },
      ]
    },
    {
      title: '작업자 안전 및 효율성 향상',
      bullets: [
      {
        label: (
          <>점화 과정에서 발생하는 위험 요소 제거로 <strong>작업자 안전 확보</strong></>
        ),
      },
      {
        label: (
          <>설치 시간 단축 및 반복 작업 간 피로 감소</>
        ),
      },
      {
        label: (
          <>신속한 경고 신호 제공으로 도로 현장의 2차 사고 예방 효과 증가</>
        ),
      },
      ]
    },
    {
      title: '현장 중심의 설계와 높은 신뢰성',
      bullets: [
      {
        label: (
          <>내구성이 뛰어난 소재 사용으로 장기간 사용 가능</>
        ),
      },
      {
        label: (
          <>각종 도로 작업·긴급 상황·교통 통제 현장에서 즉각 활용</>
        ),
      },
      {
        label: (
          <>다양한 불꽃신호기와 호환 가능한 범용성</>
        ),
      },
      ]
    },
  ];

  /* --- 사용방법(2~4컷) : 실제 이미지 경로/문구로 교체 가능 --- */
  const steps = [
    {
      image: '/images/products/traffic-safety/pyro-step1.webp',
      text: '1. 이탈방지고리를 펴고 고정 마그네틱을 이용해 차량에 부착합니다.',
    },
    {
      image: '/images/products/traffic-safety/pyro-step2.webp',
      text: '2. 스위치를 ON으로 작동시킵니다.',
    },
    {
      image: '/images/products/traffic-safety/pyro-step3.webp',
      text: '3. 불꽃신호기를 장치에 넣고 목표 지점으로 불꽃신호기를 투척합니다.',
    },
    // 필요 시 추가
    // { image: '/images/.../step3.jpg', text: 'Step 3 설명' },
    // { image: '/images/.../step4.jpg', text: 'Step 4 설명' },
  ];

  return (
    <>
      <HeroSection
        title={`불꽃신호기 점화장치`}
        subtitle={`안전문제 발생을 최소화한 자동 점화 장치로 \n2차 사고를 예방합니다`}
        backgroundImage="/images/products/traffic-safety/pyrotechnic-sign.webp"
        breadcrumbs={[
          { label: '홈', path: '/' },
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '불꽃신호기 점화장치' },
        ]}
        categories={[
          { label: '도로 안전경보시스템', path: '/products/traffic-safety' },
          { label: '도로 안전유도시설', path: '/products/guardrail' },
          { label: '도로환경 개선시설', path: '/products/facilities' },
          { label: '도로 안내표지시스템', path: '/products/signage' },
        ]}
      />

      <ProductShowcaseSection
        subtitle={`더욱 안전하게 2차 사고 예방을`}
        title={`불꽃신호기 점화장치`}
        description={
          <>
            기존의 수동 점화 방식 불꽃신호기에서 발생하던 {' '}
            <strong>착화 실패, 화상 위험, 의복 손상, 차량 손상 등의 문제를 근본적으로 해결하기 위해 개발된 차세대 안전 점화장치</strong>입니다.
            <br />
            <br />
            스위치를 ON으로 작동시키고 불꽃신호기를 장치에 서서히 넣어 <strong>안전하고 정확하게 자동 점화</strong>할 수 있어, {' '}
            누구나 쉽고 빠르게 사용할 수 있으며, 긴급 상황에서도 안정적인 경고 신호를 제공합니다. 
          </>
        }
        images={[
          '/images/products/traffic-safety/pyrotechnic-sign.webp',
          '/images/products/traffic-safety/pyrotechnic-sign2.webp',
        ]}
      />

      <SectionDivider />

      <InfoSection title="제품 구성도">
        <TypeBlock groups={compositionGroups} />
      </InfoSection>


      <InfoSection title="사용방법">
        <UsageSteps steps={steps} />
      </InfoSection>

      <InfoSection title="시연영상">
        <VideoBlock
          src="/videos/pyrotechnic-sign.mp4"
        />
      </InfoSection>

      <InfoSection title="제품 특징">
        <FeatureList features={features} />
      </InfoSection>

      <ProductDetailNav
        category="traffic-safety"
        currentPath="/products/traffic-safety/pyrotechnic-sign"
        listPath="/products/traffic-safety"
      />


      <CTASection />
    </>
  );
};

export default PyrotechnicSign;
